export default "__VITE_ASSET__DaN0zI4F__"